import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  makeStyles,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Grid,
} from "@material-ui/core";
import { Note } from "@material-ui/icons";
import { ModalComentario } from "../../ModalGestionReclamos/ModalComentario";
import { FormComentarioExterno } from "./FormComentarioExterno";
import { AREAS_FISICAS, TIPO_COMENTARIOS_RECLAMOS } from "../../../../../utils/constants";
import ModalAbm from "../../../../compartidos/abms/ModalAbm";
import { FetchComentariosExternos } from "../../../../../actions/reclamos/reclamosExternosActions";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
  },
  switchBase: {
    color: "#bdbdbd",
    "&$checked": {
      transform: "translateX(16px)",
      color: "#4CAF50",
      "& + $track": {
        backgroundColor: "#3E8040",
        opacity: 1,
        border: "none",
      },
    },
  },
  checked: {},
  track: {},
  hoverNota: {
    "&:hover": {
      backgroundColor: "#80808026",
      cursor: "pointer",
    },
  },
}));

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};



export const InformacionReclamoExterno = ({ solicitud, disabled }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openAlta, setOpenAlta] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("");
  const [editNota, setEditNota] = useState(null);

  const { comentarios = {} } = useSelector((state) => state.reclamos);
  const { idUsuario } = useSelector((state) => state.auth);
  const { areasFisicasUsuario } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(FetchComentariosExternos(solicitud?.id));
  }, [dispatch])


  const cerrarModalAlta = () => setOpenAlta(false);


  const disabledComentario = areasFisicasUsuario?.idArea === AREAS_FISICAS.COMUNICACIONES ? false : true

  return (
    <>
      <Grid item xs={12}>
        {openModal && (
          <ModalComentario
            open={openModal}
            close={() => {
              setOpenModal(false);
            }}
            cancelarModal={() => {
              setOpenModal(false);
            }}
            disabled={true}
            titulo={tituloModal}
            nota={editNota}
          />
        )}
        <Grid container justify="center" alignItems="center">
          <Grid
            item
            xs={12}
            md={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Typography align="left" variant="button" color="secondary">
              <span>
                TIPO:{" "}
                <span className={classes.title}>
                  {solicitud?.descripcionTipoReclamo}
                </span>
              </span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Typography align="left" variant="button" color="secondary">
              <span>
                ORIGEN:{" "}
                <span className={classes.title}>
                  {solicitud?.descripcionTipoOrigen}
                </span>
              </span>
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Typography align="left" variant="button" color="secondary">
              <span>
                DESCRIPCION:{" "}
                <span className={classes.title}>{solicitud?.descripcion}</span>
              </span>
            </Typography>
          </Grid>
          <ModalAbm
            title="Agregar Comentario"
            open={openAlta}
            setOpen={setOpenAlta}
          >
            <FormComentarioExterno
              solicitud={solicitud.id}
              cerrarModal={cerrarModalAlta}
              cancelarModal={cerrarModalAlta}
            />
          </ModalAbm>
          <Grid item xs={12}>
            <Button
              disabled={disabled}
              variant="contained"
              color="primary"
              onClick={() => setOpenAlta(true)}
              style={{ float: "right", marginTop: "1rem" }}
            >
              + Agregar Comentario
            </Button>
          </Grid>
          <Grid item xs={12} md={12} style={{ marginTop: "2rem" }}>
            {Array.isArray(comentarios) && comentarios?.length > 0 ? (
              <List>
                {comentarios.map((nota) => (
                  <ListItem
                    key={nota.id}
                    className={classes.hoverNota}
                    disabled={disabledComentario && !((nota.idTipoComentario === TIPO_COMENTARIOS_RECLAMOS.PUBLICO) || (nota.idTipoComentario === TIPO_COMENTARIOS_RECLAMOS.PRIVADO && nota.idUsuarioCarga === idUsuario))}
                    onClick={() => {
                      if (disabledComentario && !((nota.idTipoComentario === TIPO_COMENTARIOS_RECLAMOS.PUBLICO) || (nota.idTipoComentario === TIPO_COMENTARIOS_RECLAMOS.PRIVADO && nota.idUsuarioCarga === idUsuario))) {
                        return;
                      }
                      setTituloModal("Descripcion Comentario");
                      setEditNota(nota);
                      setOpenModal(true);
                    }}
                  >
                    <ListItemAvatar>
                      <Note />
                    </ListItemAvatar>
                    <ListItemText
                      primary={nota.tipoComentario}
                      secondary={new Date(nota.fechaCarga).toLocaleString(
                        "es",
                        optionsfecha
                      )}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography
                style={{
                  fontSize: "1.1rem",
                  fontStyle: "italic",
                  marginBottom: "1rem",
                }}
              >
                No hay comentarios
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}